import { render } from "./item-option-modal.vue?vue&type=template&id=8b673286"
import script from "./item-option-modal.vue?vue&type=script&lang=js"
export * from "./item-option-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__